import React, { createContext, useState, useMemo, useEffect, useCallback } from "react";

import {
  PathwayService,
  StandardPathwayResponse,
  StandardPathwayServiceState,
  ServiceStatusEnum,
  CurrentActivityResponse
} from "@imaginelearning/mps-api-service";

const defaultPathwayState: StandardPathwayServiceState<StandardPathwayResponse> = {
  status: ServiceStatusEnum.LOADING,
  response: ""
};

const defaultCurrentActivityState: StandardPathwayServiceState<CurrentActivityResponse> = {
  status: ServiceStatusEnum.LOADING,
  response: ""
};
const defaultDispatchBoolean: React.Dispatch<React.SetStateAction<boolean>> = (val) => val;

const defaultState = {
  pathway: defaultPathwayState,
  currentActivity: defaultCurrentActivityState,
  showTokenExpiredAlert: false,
  setShowTokenExpiredAlert: defaultDispatchBoolean,
  fetchCurrentActivity: async (studentId: string, studentPathwayId: string, selectedLessonId: string) => {
    // Declare the 'attemptId' variable and provide an initializer
    const attemptId = "123";
    // Return a mock response for now
    return { response: { studentId, attemptId } } as StandardPathwayServiceState<CurrentActivityResponse>;
  },
  fetchPathway: async (studentId: string, pathwayId: string) => { }
};
export const PathwayContext = createContext(defaultState);

export function PathwayProvider(props: any) {
  const [pathway, setPathway] = useState<StandardPathwayServiceState<StandardPathwayResponse>>(defaultPathwayState);
  const [currentActivity, setCurrentActivity] =
    useState<StandardPathwayServiceState<CurrentActivityResponse>>(defaultPathwayState);
  // const [forceRefetch, getUpdatedPathway] = useState("");
  const [showTokenExpiredAlert, setShowTokenExpiredAlert] = useState(false);

  const fetchPathway = async (studentId: string, pathwayId: string) => {
    const result: StandardPathwayServiceState<StandardPathwayResponse> = await PathwayService.standardPathway(
      studentId,
      pathwayId
    );
    setPathway(result);
  };

  const fetchCurrentActivity = useCallback(
    async (studentId: string, studentPathwayId: string, selectedLessonId: string) => {
      const result = await PathwayService.currentActivity(studentId, studentPathwayId);

      // Only set the current activity if selectedLessonId matches response.lessonId or if selectedLessonId is not provided
      if (!selectedLessonId || result.response?.lessonId === selectedLessonId) {
        setCurrentActivity(result);
      }

      return result;
    },
    [setCurrentActivity]
  );

  const value = useMemo(
    () => ({
      pathway,
      currentActivity,
      showTokenExpiredAlert,
      setShowTokenExpiredAlert,
      fetchCurrentActivity,
      fetchPathway
    }),
    [showTokenExpiredAlert, pathway, currentActivity, fetchCurrentActivity, fetchPathway]
  );

  return <PathwayContext.Provider value={value} {...props} />;
}
